import { Icon } from "@iconify/react";
import { useQuery } from "@tanstack/react-query";
import { useTicketApi } from "@/api/tickets";
import { RequestBoundary } from "@/components/request-boundary";
import { useI18n } from "@/locales/i18n-provider";
import { getLinkedEntityRenderer } from "./linked-entities/renderers";

export function TicketLinkedEntityList({ ticketId }: { ticketId: string }) {
  const { t } = useI18n();
  const ticketApi = useTicketApi();
  const query = useQuery({
    queryKey: ["tickets", "linked-entities", ticketId],
    queryFn: ({ signal }) => ticketApi.getLinkedEntities(ticketId, signal),
  });

  return (
    <RequestBoundary
      empty={{
        icon: <Icon className="size-5" icon="tabler:database-off" />,
        title: t("tickets.linked.emptyTitle"),
        description: t("tickets.linked.emptyDescription"),
      }}
      isEmpty={(data) => data.length === 0}
      loadingLabel={t("tickets.linked.loading")}
      query={query}
    >
      {(linkedEntities) => (
        <ul aria-label={t("tickets.linked.listAria")} className="mx-auto w-full max-w-3xl space-y-3 p-4">
          {linkedEntities.map((link) => {
            const Renderer = getLinkedEntityRenderer(link);
            return <Renderer key={link.id} link={link} ticketId={ticketId} />;
          })}
        </ul>
      )}
    </RequestBoundary>
  );
}
